import { ItemTypes } from "../../data/ItemOfBusiness";
import { MeetingStatus } from "../../data/MeetingStatus";
import { markdownDiff } from "../diff/markdownDiff";

/**
 * Returns the markdown to display for the current item of business.
 *
 * Preference order:
 *  1. Organiser-authored mark-up (`markedUpText`) — WYSIWYG, the default for
 *     new amendments.
 *  2. Computed diff (legacy) — items from past years that carry no authored
 *     mark-up fall back to the automatic diff.
 */
export function GetItemMarkdown(meetingStatus: MeetingStatus | null, showPreview: boolean): string {
  let item = meetingStatus?.currentItem;
  if (item == null) {
    return "";
  }
  // if there is a preview amendment and the caller may see it, show that
  if (meetingStatus?.previewAmendment && showPreview) {
    const preview = meetingStatus.previewAmendment;
    if (preview.markedUpText) {
      return preview.markedUpText;
    }
    return markdownDiff(item.text, preview.text, item.diffMode);
  }
  // legislation amendments diff against their own original text
  if (item.type === ItemTypes.LegislationAmendment) {
    if (item.markedUpText) {
      return item.markedUpText;
    }
    return markdownDiff(item.originalText, item.text, item.diffMode);
  }
  // original motions and accepted motions-as-amended are shown as clean text
  if (item.type === ItemTypes.OriginalMotion || item.type === ItemTypes.MotionAsAmended) {
    return item.text;
  }
  // amendments: authored mark-up wins; otherwise diff against the previous version
  if (item.markedUpText) {
    return item.markedUpText;
  }
  let previous = meetingStatus?.previousAmendmentItem;
  return markdownDiff(previous?.text ?? item.text, item.text, item.diffMode);
}
